import { Provider } from "./components";
import Group from "./MedicationGroup";

type InternalGroup = typeof Group;

interface ExportGroup extends InternalGroup {
  Provider: typeof Provider;
}

const MedicationGroup = Group as ExportGroup;
MedicationGroup.Provider = Provider;

export default MedicationGroup;
